require('./result_functions.js'); 
require('./forms.js');
require('./filter.js');
require('./ajax.js');
require('./slideshow.js');
require('./cookies.js');
//require('./modals.js');
require('./vote.js');
require('./facebook.js');
require('./flash.js'); 
require('./other.js');


// WEBPACK FOOTER //
// ./assets/js/theme.js